import React from 'react';
import { ArrowRight } from 'lucide-react';

const CLIENT_IMG = 'https://static.prod-images.emergentagent.com/jobs/0ca1b2c0-495a-4032-aa3f-8b74f40e0c75/images/27967cf084225545f2e7a77f6d0ccb8e625f11763faef800e2476d6ee5d19dd4.jpeg';
const COURIER_IMG = 'https://static.prod-images.emergentagent.com/jobs/0ca1b2c0-495a-4032-aa3f-8b74f40e0c75/images/263f6f4e4441c20151df3c1b6fc6ec2ccb034dedaa277e4e51896bff2da0e9f2.jpeg';

const HeroHalf = ({ image, alt, eyebrow, title, text, cta, href, testId, delay }) => (
  <a
    href={href}
    className="group relative flex min-h-[60vh] md:min-h-[78vh] overflow-hidden"
    data-testid={`${testId}-panel`}
  >
    <img
      src={image}
      alt={alt}
      className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-105"
    />
    <div className="absolute inset-0 bg-gradient-to-t from-slate-950/90 via-slate-950/40 to-slate-950/10" />
    <div
      className="relative mt-auto p-8 md:p-12 lg:p-16 max-w-xl opacity-0 animate-[heroIn_0.8s_ease-out_forwards]"
      style={{ animationDelay: delay }}
    >
      <div className="inline-block text-xs tracking-[0.2em] uppercase font-bold text-[#6ee7b7] bg-slate-950/50 backdrop-blur-sm px-3 py-1.5 rounded-full mb-4">{eyebrow}</div>
      <h2 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white tracking-tight leading-[1.05] mb-5">
        {title}
      </h2>
      <p className="text-base md:text-lg text-white/85 leading-relaxed mb-8">{text}</p>
      <span
        className="inline-flex items-center gap-2 bg-[#10b981] group-hover:bg-[#059669] text-white px-7 py-4 rounded-xl font-semibold shadow-lg transition-colors"
        data-testid={testId}
      >
        {cta}
        <ArrowRight className="w-5 h-5 transition-transform group-hover:translate-x-1" />
      </span>
    </div>
  </a>
);

export const HeroSplit = () => (
  <section className="pt-20" data-testid="hero-split">
    <style>{'@keyframes heroIn{from{opacity:0;transform:translateY(24px)}to{opacity:1;transform:none}}'}</style>
    <h1 className="sr-only">O transporte rápido que precisa. O rendimento extra que procura.</h1>
    <div className="grid md:grid-cols-2">
      <HeroHalf
        image={CLIENT_IMG}
        alt="Pessoa a pensar em como transportar um sofá e caixas"
        eyebrow="Para quem envia"
        title="O transporte rápido que precisa."
        text="Do sofá às caixas da mudança: tire uma foto, a nossa IA indica o veículo certo e um estafeta trata do resto."
        cta="Quero Enviar"
        href="#clientes"
        testId="hero-cta-client"
        delay="0.1s"
      />
      <HeroHalf
        image={COURIER_IMG}
        alt="Estafeta sorridente junto à sua carrinha de entregas"
        eyebrow="Para quem tem carrinha"
        title="O rendimento extra que procura."
        text="Tem uma carrinha? Faça entregas quando quiser, perto de si, e ganhe um rendimento extra com a TugGo."
        cta="Quero Entregar"
        href="#estafetas"
        testId="hero-cta-courier"
        delay="0.3s"
      />
    </div>
  </section>
);
